import ClientManagementStore from "../../modules/Admin/ClientManagement/store";
import {
  ClientUserPreferenceDto,
  SaveClientUserPreferencesDto,
} from "../../modules/Admin/ClientManagement/types";
import { MessageResultState } from "../../types/general-types";

/**
 * Kullanıcının kendi kart tercihleri. `clientCategories.ts` ile aynı gerekçe: uçuştaki
 * istek paylaşılır, sonuç önbelleğe alınmaz çünkü kullanıcı ekranda değiştirebiliyor.
 */
let pending: Promise<ClientUserPreferenceDto[]> | null = null;

export function fetchUserPreferences(): Promise<ClientUserPreferenceDto[]> {
  if (pending) return pending;

  pending = new ClientManagementStore()
    .getMyPreferences()
    .then((response) => {
      pending = null;
      // Hata toast'ını axios interceptor basıyor; tercih okunamazsa ekran varsayılan görünür.
      if (response?.state !== MessageResultState.SUCCESS) return [];
      return response.result || [];
    })
    .catch(() => {
      pending = null;
      return [];
    });

  return pending;
}

export function invalidateUserPreferences(): void {
  pending = null;
}

export function saveUserPreferences(
  dto: SaveClientUserPreferencesDto
): Promise<boolean> {
  return new ClientManagementStore()
    .saveMyPreferences(dto)
    .then((response) => {
      invalidateUserPreferences();
      return response?.state === MessageResultState.SUCCESS;
    })
    .catch(() => false);
}
